<div class="lum-c-channel-table">
  <div
    class="overlay"
    lumAppLoader
    [loading]="(loading$ | async) || false"
    [classes]="'loading blur'"
  ></div>

  <table
    *ngIf="(channels$ | async)?.length && !(loading$ | async); else empty"
    class="lum-table lum-table--classic striped"
  >
    <tr>
      <th
        *ngIf="displayColumns['channel'].visible"
        class="cursor-pointer"
        (click)="onSortColumn('label')"
      >
        Channel
        <span *ngIf="sortState.column === 'label'">
          {{ sortState.direction === 'asc' ? '↑' : '↓' }}
        </span>
      </th>
      <th
        *ngIf="
          ('red_DV-3395_channel_types' | featureFlag) &&
          displayColumns['channelType'].visible
        "
        class="cursor-pointer"
        (click)="onSortColumn('channelType')"
      >
        Channel Type
        <span *ngIf="sortState.column === 'channelType'">
          {{ sortState.direction === 'asc' ? '↑' : '↓' }}
        </span>
      </th>
      <th
        *ngIf="displayColumns['warehouseGroup'].visible"
        class="cursor-pointer"
        (click)="onSortColumn('warehouse_group_label')"
      >
        Warehouse Group
        <span *ngIf="sortState.column === 'warehouse_group_label'">
          {{ sortState.direction === 'asc' ? '↑' : '↓' }}
        </span>
      </th>
      <th
        *ngIf="displayColumns['remarks'].visible"
        class="cursor-pointer"
        (click)="onSortColumn('description')"
      >
        Remarks
        <span *ngIf="sortState.column === 'description'">
          {{ sortState.direction === 'asc' ? '↑' : '↓' }}
        </span>
      </th>
      <th *ngIf="displayColumns['posChannel'].visible" class="cursor-pointer">
        Internal Sales Channel
      </th>
      <th *ngIf="displayColumns['pullStocks'].visible" class="cursor-pointer">
        Get Orders
      </th>
      <th *ngIf="displayColumns['pushStocks'].visible" class="cursor-pointer">
        Push Orders
      </th>
      <th
        *ngIf="displayColumns['pushStocksToChannel'].visible"
        class="cursor-pointer"
      >
                                  Push Stock to Integration
      </th>
      <th
        *ngIf="displayColumns['tags'].visible"
        class="cursor-pointer"
        (click)="onSortColumn('tags')"
      >
        Tags
      </th>
      <th *ngIf="displayColumns['active'].visible" class="cursor-pointer">
        Active
      </th>
      <th></th>
    </tr>
    <tbody>
      <ng-container *ngFor="let channel of channels$ | async; trackBy: trackById">
        <tr>
          <td *ngIf="displayColumns['channel'].visible">
            <a [routerLink]="['/channels/v2', channel.id, 'view']">{{
              channel?.label
            }}</a>
          </td>
          <td
            *ngIf="
              ('red_DV-3395_channel_types' | featureFlag) &&
              displayColumns['channelType'].visible
            "
          >
            {{ channelTypeLabels[channel?.channelType] || '-' }}
          </td>
          <td *ngIf="displayColumns['warehouseGroup'].visible">
            {{ channel?.warehouseGroup?.label }}
          </td>
          <td *ngIf="displayColumns['remarks'].visible">
            {{ channel?.description }}
          </td>
          <td *ngIf="displayColumns['posChannel'].visible">
            <span *ngIf="channel?.isPOSChannel; else notPOSChannel">
              <i class="fas fa-check text-green-700" role="presentation"></i>
              <span class="sr-only">Yes</span>
            </span>
            <ng-template #notPOSChannel>-</ng-template>
          </td>
          <td *ngIf="displayColumns['pullStocks'].visible">
            <span
              *ngIf="
                channel?.pullOrderIntegrationMapping;
                else noPullOrderIntegrationMapping
              "
            >
              <ng-template #pullOrderCellContent>
                {{
                  channel?.pullOrderIntegrationMapping?.appIntegrationAccountName ||
                    ''
                }}
                <ng-container
                  *ngIf="channel?.pullOrderIntegrationMapping?.storeName"
                >
                  - {{ channel?.pullOrderIntegrationMapping?.storeName }}
                </ng-container>
              </ng-template>
              <a
                *ngIf="channel.pushInventoryEnabled; else noLink"
                [routerLink]="
                  '/settings/app-integration-account-settings/' +
                  channel?.pullOrderIntegrationMapping?.appIntegrationAccountId +
                  '/manage/products'
                "
                title="Manage Product Mapping"
              >
                <ng-container
                  *ngTemplateOutlet="pullOrderCellContent"
                ></ng-container>
              </a>
              <ng-template #noLink>
                <ng-container
                  *ngTemplateOutlet="pullOrderCellContent"
                ></ng-container>
              </ng-template>
            </span>
            <ng-template #noPullOrderIntegrationMapping>-</ng-template>
          </td>

          <td *ngIf="displayColumns['pushStocks'].visible">
            <span
              *ngIf="
                channel?.pushOrderIntegrationMapping;
                else noshllOrderIntegrationMapping
              "
            >
              {{
                channel?.pushOrderIntegrationMapping?.appIntegrationAccountName ||
                  ''
              }}
              {{
                channel?.pushOrderIntegrationMapping?.storeName
                  ? ' - ' + channel?.pushOrderIntegrationMapping?.storeName
                  : ''
              }}
            </span>
            <ng-template #noshllOrderIntegrationMapping>-</ng-template>
          </td>
          <td *ngIf="displayColumns['pushStocksToChannel'].visible">
            <span
              *ngIf="
                channel?.pushStockIntegrationMapping;
                else noPushStockIntegrationMapping
              "
            >
              {{
                channel?.pushStockIntegrationMapping?.appIntegrationAccountName ||
                  '-'
              }}
            </span>
            <ng-template #noPushStockIntegrationMapping>-</ng-template>
          </td>
          <td *ngIf="displayColumns['tags'].visible">
            <span
              *ngFor="let tag of channel?.tags; trackBy: trackById"
              class="mr-2"
            >
              {{ tag?.name }}
            </span>
          </td>
          <td *ngIf="displayColumns['active'].visible">
            <mat-slide-toggle
              (change)="onToggleStatusChange($event, channel.id)"
              [checked]="channel?.status === 1 ? true : false"
            ></mat-slide-toggle>
          </td>
          <td class="flex justify-end position-sticky" style="right: 0">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </tr>
        <mat-menu #menu="matMenu">
          <button
            [routerLink]="['/channels/v2', channel?.id, 'view']"
            mat-menu-item
          >
            View
          </button>
          <button
            [routerLink]="['/channels/v2', channel?.id, 'edit']"
            mat-menu-item
          >
            Edit
          </button>
          <button (click)="onConfirmDelete(channel?.id)" mat-menu-item>
            Delete
          </button>
          <button
            *ngIf="!channel?.store_type"
            (click)="onRenewQuickbooksToken(channel?.id)"
            mat-menu-item
          >
            <i class="fas fa-exchange-alt text-danger"></i> Renew Quickbooks Tokens
          </button>
          <button
            *ngIf="channel?.store_type === 5"
            (click)="onRenewHubSpotTokens(channel?.id)"
            mat-menu-item
          >
            <i class="fas fa-exchange-alt text-danger"></i> Renew HubSpot Tokens
          </button>
          <button
            *ngIf="channel?.store_type === 5"
            (click)="onSyncHubSpot(channel)"
            mat-menu-item
          >
            <i class="fas fa-exchange-alt text-danger"></i> Sync HubSpot Data
          </button>
          <button
            *ngIf="channel?.store_type === 6"
            (click)="authorizeEcartApi(channel?.id)"
            mat-menu-item
          >
            <i class="fas fa-exchange-alt text-danger"></i> Authorize EcartApi Store
          </button>
        </mat-menu>
      </ng-container>
    </tbody>
  </table>

  <mat-paginator
    class="lum-paging lum-paging--dodge-back-to-top lum-paging--sticky"
    [length]="pagination?.total || 0"
    [pageSize]="pagination?.per_page || paginationConfig.perPage"
    [pageSizeOptions]="paginationConfig.pageSizeOptions"
    [pageIndex]="(pagination?.current_page || 1) - 1"
    (page)="onPaginationEvent($event)"
    aria-label="Select page"
  ></mat-paginator>

  <ng-template #empty>
    <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
  </ng-template>
</div>
